import { ReactSVG } from "react-svg"
const columns = [
    {
        name: "Code",
        selector: (row) => row.code,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Category Name",
        selector: (row) => row.category,
        sortable: true,
        format: (row) => {
            const fallback = 'https://dummyimage.com/600x400/000/fff&text=Laxmi+Tailors'
            const thumbnailUrl = (() => {
                if (!row || !row.thumbnail) return fallback
                if (typeof row.thumbnail === 'string') return row.thumbnail || fallback
                return row.thumbnail.thumbnail_url || row.thumbnail.url || fallback
            })()
            return (
                <div className="d-flex flex-row" style={{ alignItems: "center" }}>
                    <img src={thumbnailUrl} alt={row.name || 'Thumbnail'} style={{ height: "120px", width: "150px", borderRadius: "32px", marginRight: "16px", objectFit: 'cover' }} />
                    <div>{row.name}</div>
                </div>
            )
        }
    },
    {
        name: "Description",
        selector: (row) => row.description,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Status",
        selector: (row) => row.status,
        sortable: true,
        maxWidth: "200px",
        format: (row) => {
            return (
                <div style={{
                    padding: "4px 8px",
                    borderRadius: "4px",
                    color: row.status === "aktif" ? '#1EB200' : 'white',
                    backgroundColor: row.status === "aktif" ? '#D5FFCC' : 'red'
                }}>{row.status === "aktif" ? 'Active' : 'Non-Active'}</div>
            )
        }
    },
]

export default columns